import Typography from '@material-ui/core/Typography';
import PageTitle from '@/components/PageTitle';
import Plans from '@/components/Pricing/Plans';
import * as React from 'react';
export default {
  Typography,
  PageTitle,
  Plans,
  React
};